var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maybe-minimized"},[_c('Minimize',{attrs:{"label":_vm.name,"minimized":_vm.isMinimized},on:{"click":function($event){_vm.p_minimized = !_vm.isMinimized}}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMinimized),expression:"isMinimized"}],staticClass:"content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }